import Vue from 'vue';
import { Component, Emit, Prop } from 'vue-property-decorator';
import ToolService from '@/providers/tools';

@Component({
  components: {
  }
})
export default class EdDeckViewerControlsComponent extends Vue {
  @Prop({ default: 0 }) readonly totalCards;
  @Prop({ default: 0 }) readonly currentCard: number;
  @Prop({ default: false }) readonly hasDeckIcon: boolean;
  @Prop({ default: false }) readonly hasZoom: boolean;
  @Prop({ default: false }) readonly canZoomIn: boolean;
  @Prop({ default: false }) readonly canZoomOut: boolean;
  @Prop() readonly canFlipByOutsideCard: boolean;
  @Prop() readonly hasBackSelectedCard: boolean;
  @Prop() readonly canFlip: boolean;
  @Prop() readonly deckCardRef: any;
  @Prop() readonly maxContainerWidth: any;
  
  readonly onNextCard = 'onNextCard';
  readonly onPrevCard = 'onPrevCard';
  readonly onDeckIconOver = 'onDeckIconOver';
  readonly onHideSideBar = 'onHideSideBar';

  isMobile = false;

  @Emit('onZoomIn')
  onZoomIn() {
    return true
  }

  @Emit('onZoomOut')
  onZoomOut() {
    return true
  }

  @Emit('onResetZoom')
  onResetZoom() {
    return true
  }

  @Emit('onFlipCard')
  onFlipCard() {
    return true
  }
  
  get hasNext() {
    return this.currentCard < this.totalCards - 1;
  }

  get hasPrev() {
    return this.currentCard > 0;
  }

  get allowedZoomIn() {
    const width = this.deckCardRef?.cardStyles?.width || '';
    return Number(width.replace('px', '')) * this.deckCardRef?.scale <= this.maxContainerWidth;
  }

  get allowedZoomOut() {
    const width = this.deckCardRef?.cardStyles?.width || '';
    return Number(width.replace('px', '')) * this.deckCardRef?.scale >= 200;
  }

  nextCard() {
    if (this.hasNext){
      this.$emit(this.onNextCard);
    }
  }

  prevCard() {
    if (this.hasPrev) {
      this.$emit(this.onPrevCard);
    }
  }

  triggerDeckIconOver() {
    if (ToolService.getIsMobileDevice()) {
      this.$emit(this.onDeckIconOver);
    }
  }

  onMouseOverDeckIcon() {
    if (!ToolService.getIsMobileDevice()) {
      this.$emit(this.onDeckIconOver);
    }
  }

  handleKeydown (e) {
    if(this.currentCard < 0) {
      return;
    }

    switch (e.keyCode) {
      case 38:
        this.prevCard();
        break;
      case 40:
        this.nextCard();
        break;
    }
  }

  created() {
    document.addEventListener('keydown', this.handleKeydown, null);
  }

  destroyed() {
    document.removeEventListener('keydown', this.handleKeydown);
  }
}
